import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "contactInputGrid" }
const _hoisted_2 = { style: {"grid-column":"left","justify-self":"end","margin-top":"0.45rem"} }
const _hoisted_3 = {
  style: {"grid-column":"right"},
  class: "row"
}

import { ref, onMounted, watch } from 'vue';
import { getFormattedCnsPrefixForPwr } from '@/functions/lu.js';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import relationshipapi from '@/api/relationshipapi';
import { ApiError } from '@/models/share.model';
import { toastError, toastSuccess } from '@/utils/toast-utils';
import { useI18n } from 'vue-i18n';
import { useToast } from 'primevue';
import { useAppUserStore } from '@/stores/appUser';
import EsModal from '@/components/modals/esModal.vue';

const CNS_LENGTH = 13;

export default /*@__PURE__*/_defineComponent({
  __name: 'cnsIdInput',
  props: {
  isOpen: {
    type: Boolean,
    required: true
  },
  cns: {
    type: Object,
    required: false,
  },
},
  emits: ['close'],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit;
const focusRef = ref(null);
const currentEntryStore = useCurrentEntryStore();
const appUserStore = useAppUserStore()
const { t } = useI18n();
const toast = useToast();

const cnsInput = ref(props.cns?.cnsSuffix || "")

async function updateCnsSuffixInput() {
  if (cnsInput.value.length !== CNS_LENGTH) {
    toastError(toast, {
      summary: t('common.toast.error'),
      detail: t('error.PERSON_CNS_NUMBER_ERROR')
    });
    // To comply with v-one-click directive
    throw new Error('Matricule wrong size');
  }
  const relationshipId = props.cns?.relationshipId || null;
  try {
    await relationshipapi.updateLuCnsAffiliationNumber(
      relationshipId, 
      cnsInput.value, 
      appUserStore.currentHealthGroupMembership.instituteWithRole.instituteWithRoleId
    );
    await currentEntryStore.reloadPatientOnly();
    toastSuccess(toast, {
      summary: t('common.toast.success.update'),
      detail:  t('patient.admin.cnsUpdate.message')
    });
    emits('close');
  } catch (error: unknown) {
    const apiError = error as ApiError;
    toastError(toast, {
        summary: t('common.toast.error'),
        detail: t(`error.${apiError.status}`)
    });
    // To comply with v-one-click directive
    throw apiError;
  }
  
  return true;
}

watch(
  () => props.isOpen,
  (value) => {
    if (value) {
      let prefix = "";
      const pwrPatient = currentEntryStore.modalPatient;
      const birthDate = getFormattedCnsPrefixForPwr(pwrPatient);
      if (birthDate) {
        prefix = birthDate.replaceAll(' ', '');
      }
      const suffix = props.cns?.cnsSuffix ?? "";
      cnsInput.value = prefix + suffix;
    }
  }
);

onMounted(() => {
  focusRef.value?.innerRef?.focus();
});

return (_ctx: any,_cache: any) => {
  const _component_text_item = _resolveComponent("text-item")!
  const _component_inputLineNew2 = _resolveComponent("inputLineNew2")!
  const _component_inputBox = _resolveComponent("inputBox")!
  const _component_es_modal_footer = _resolveComponent("es-modal-footer")!

  return (_openBlock(), _createBlock(EsModal, {
    title: _unref(t)('patient.cns.addCard.title'),
    isOpen: props.isOpen,
    dismissable: ""
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_es_modal_footer, {
        onModalCancel: _cache[1] || (_cache[1] = ($event: any) => (emits('close'))),
        "confirm-modal-method": updateCnsSuffixInput
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_text_item, {
            txt: "Numéro CNS",
            styles: "main-m"
          })
        ]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_inputBox, null, {
            default: _withCtx(() => [
              _createVNode(_component_inputLineNew2, {
                ref_key: "focusRef",
                ref: focusRef,
                modelValue: cnsInput.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((cnsInput).value = $event)),
                maxlength: CNS_LENGTH
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "isOpen"]))
}
}

})